// extracted by mini-css-extract-plugin
export default {"footer":"c-e_cU"};